module.exports = __webpack_public_path__ + "static/media/qa-arrow.1c1da689.svg";